import Vue from "vue";
import VueRouter from "vue-router";

import { isDev, isLocal, isElectron } from "./utils/env-utils";
import routes from "./routes";
import { supabase } from "@/utils/supabase";

// BACKDOOR
import { BACKDOOR_ROUTES, SANDBOX_ROUTES, LAB_ROUTES, DEPRECATED_ROUTES } from "./routes-extra";
if (isLocal() || isDev()) routes.push(...BACKDOOR_ROUTES);
if (isLocal() || isDev()) routes.push(...SANDBOX_ROUTES);
if (isLocal() || isDev()) routes.push(...LAB_ROUTES);
if (isLocal() || isDev()) routes.push(...DEPRECATED_ROUTES);

if (isLocal() || isDev()) {
  // Remove fallback router in dev mode
  // const index = routes.find((route) => route.path === "*");
  // routes.splice(routes.indexOf(index), 1);
}

Vue.use(VueRouter);

// Electron(file://)은 history 모드 불가 → hash 유지. 웹은 history 모드(클린 URL).
const router = new VueRouter({
  mode: isElectron() ? "hash" : "history",
  base: process.env.BASE_URL,
  routes,
});

import InMemoryStorage from "./domain/storage/InMemoryStorage";
import SupabaseApi from "./api/SupabaseApi";

// 라우트별 favicon 교체: meta.favicon 있으면 그걸로, 없으면 기본 favicon.
function setFavicon(file) {
  let link = document.querySelector("link[rel='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.type = file.endsWith(".svg") ? "image/svg+xml" : "image/x-icon";
  link.href = `${process.env.BASE_URL}${file}`;
}
router.afterEach((to) => {
  setFavicon(to.meta && to.meta.favicon ? to.meta.favicon : "favicon.ico");
});

// ── 인증 가드 ──
// 공개(비로그인) 경로 프리픽스 — 그 외 전부 로그인 필요.
//  /on-air·/live: OBS 송출(토큰 기반, anon) — 절대 로그인 요구 금지
//  /temp·/s·/mod-dev: 로컬/dev 전용 페이지, "/"=OAuth(pkce) 복귀 지점(code 교환 전이라 세션 없음)
const PUBLIC_PREFIXES = ["/login", "/on-air", "/live", "/policy", "/pricing", "/404", "/temp", "/s", "/mod-dev", "/social/broadcast"];
const isPublicPath = (path) => path === "/" || PUBLIC_PREFIXES.some((p) => path === p || path.startsWith(p + "/"));

router.beforeEach(async (to, from, next) => {
  if (isPublicPath(to.path)) return next();
  const {
    data: { session },
  } = await supabase.auth.getSession();
  if (!session) return next("/login"); // 세션 없이 보호 페이지 진입 → 깊은 곳(엣지 401)에서 터지기 전에 차단
  next();
});

// 세션 소멸(토큰 폐기·다른 탭 로그아웃) 실시간 반영 — 레거시 키 정리 + 보호 페이지면 로그인으로.
//  (userEmail만 남아 "로그인된 척"하는 반쪽 상태 방지)
supabase.auth.onAuthStateChange((event) => {
  if (event !== "SIGNED_OUT") return;
  try {
    localStorage.removeItem("auth/role");
  } catch (e) {
    /* noop */
  }
  const cur = router.currentRoute;
  if (cur && !isPublicPath(cur.path)) router.push("/login").catch(() => {});
});

const debug = (...args) => {
  console.log(...args);
};

export default router;
